import moment from 'moment-mini'

export default {
  name: 'KCalendarCell',
  inject: ['context'],
  props: {
    value: moment,
    referenceValue: moment,
  },
  data() {
    return {}
  },
  computed: {
    date() {
      return this.value.format('D')
    },
    belongCurrentMonth() {
      return this.referenceValue.month() === this.value.month()
    },
    isToday() {
      return this.value.isSame(this.now, 'day')
    },
    selectedValue() {
      return this.$parent.value
    },
    hoveredValue() {
      return this.$parent.hoveredCell && this.$parent.hoveredCell.value
    },
    css() {
      const hovered = this.value.isSame(this.hoveredValue, 'day')

      const css = {
        'km-calendar__cell': true,
        'km-calendar__cell--silent': !this.belongCurrentMonth,
        'km-calendar__cell--now': this.isToday,
        'km-calendar__cell--hovered': hovered,
        'km-calendar__cell--active': this.selectedValue && this.selectedValue.isSame(this.value, 'day'),
      }

      if (!this.belongCurrentMonth) {
        return css
      }

      return css
    },
  },
  watch: {},
  created() {
  },
  methods: {
    getEvents() {
      const events = {
        click: () => {
          if (this.disabled) {
            return
          }
          this.$parent.handleCellClick(this)
        },
        mouseenter: () => {
          if (this.disabled) {
            return
          }
          this.$parent.handleCellHover(this)
        },
        mouseleave: () => {
          this.$parent.handleCellLeave(this)
        },
      }

      return events
    },
  },
  render() {
    const events = this.getEvents()

    const data = {
      class: this.css,
      on: events,
    }

    return (
      <div
        {...data}>
        <div
          class="km-calendar__date"
        >
          <div class="km-calendar__value">
            {this.date}
          </div>
          <div class="km-calendar__content">
          </div>
        </div>
      </div>
    )
  },
}
